const state = {
  times: [],
  numberOfPeople: [],
  transportType: ['Car', 'Bicycle', 'Two Wheeler', 'Bus', 'Train']
}

const getters = {
  times (state) {
    return state.times
  },

  transportType (state) {
    return state.transportType
  },

  numberOfPeople (state) {
    return state.numberOfPeople
  }
}

const mutations = {
  setTimes(state, times) {
    state.times = times
  },

  numberOfPeople (state, numberOfPeople) {
    state.numberOfPeople = numberOfPeople
  }
}

const actions = {
  init ({ commit }) {
    // Times
    let times = []
    let halfHours = ['00', '30']

    for (var i = 0; i < 24; i++) {
      var j = i;
      for (var k = 0; k < 2; k++) {
        if (k == 0)
          times.push(i + ":" + halfHours[k] + " - " + (i) + ":" + halfHours[k + 1]);
        if (k == 1)
          times.push(i + ":" + halfHours[k] + " - " + (i + 1) + ":" + halfHours[k - 1]);
      }
    }

    commit('setTimes', times)

    let numberOfPeople = []
    for (var k = 1; k < 100; k++) {
      numberOfPeople.push(k)
    }

    commit('numberOfPeople', numberOfPeople)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
